import { useEffect } from 'react'

import { handlePosShortcutKeyDown } from '@/components/pos/posShortcuts'

/**
 * @param {object} options
 * @param {import('@/types/api').Sale | null} options.sale
 * @param {boolean} options.mutating
 * @param {boolean} options.paymentOpen
 * @param {boolean} options.suspendedOpen
 * @param {boolean} options.appointmentOpen
 * @param {boolean} options.packageOpen
 * @param {boolean} options.redeemOpen
 * @param {boolean} options.discountOpen
 * @param {boolean} options.noteOpen
 * @param {boolean} options.customerHistoryOpen
 * @param {number | null} options.selectedLineId
 * @param {() => void} options.onFocusCustomer
 * @param {() => void} options.onOpenPayment
 * @param {() => void | Promise<void>} options.onHoldSale
 * @param {() => void | Promise<void>} options.onOpenSuspended
 * @param {() => void | Promise<void>} options.onClosePayment
 * @param {() => void} options.onCloseSuspended
 * @param {() => void} options.onCloseAppointment
 * @param {() => void} options.onClosePackage
 * @param {() => void} options.onCloseRedeem
 * @param {() => void} options.onAppointmentShortcut
 * @param {() => void} options.onPackageShortcut
 * @param {() => void} options.onRedeemShortcut
 * @param {(lineId: number, quantity: number) => void | Promise<void>} options.onChangeLineQuantity
 */
export function usePosKeyboard(options) {
  const {
    sale,
    mutating,
    paymentOpen,
    suspendedOpen,
    appointmentOpen,
    packageOpen,
    redeemOpen,
    discountOpen,
    noteOpen,
    customerHistoryOpen,
    selectedLineId,
    onFocusCustomer,
    onOpenPayment,
    onHoldSale,
    onOpenSuspended,
    onOpenDiscount,
    onOpenVoucher,
    onClosePayment,
    onCloseSuspended,
    onCloseAppointment,
    onClosePackage,
    onCloseRedeem,
    onCloseDiscount,
    onCloseNote,
    onCloseCustomerHistory,
    onClearLineSelection,
    onAppointmentShortcut,
    onPackageShortcut,
    onRedeemShortcut,
    onChangeLineQuantity,
  } = options

  useEffect(() => {
    function handleKeyDown(event) {
      handlePosShortcutKeyDown(event, {
        sale,
        mutating,
        paymentOpen,
        suspendedOpen,
        appointmentOpen,
        packageOpen,
        redeemOpen,
        discountOpen,
        noteOpen,
        customerHistoryOpen,
        selectedLineId,
        onFocusCustomer,
        onOpenPayment,
        onHoldSale,
        onOpenSuspended,
        onOpenDiscount,
        onOpenVoucher,
        onClosePayment,
        onCloseSuspended,
        onCloseAppointment,
        onClosePackage,
        onCloseRedeem,
        onCloseDiscount,
        onCloseNote,
        onCloseCustomerHistory,
        onClearLineSelection,
        onAppointmentShortcut,
        onPackageShortcut,
        onRedeemShortcut,
        onChangeLineQuantity,
      })
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [
    mutating,
    onAppointmentShortcut,
    onChangeLineQuantity,
    onClosePayment,
    onCloseSuspended,
    onCloseAppointment,
    onClosePackage,
    onCloseRedeem,
    onFocusCustomer,
    onHoldSale,
    onOpenPayment,
    onOpenSuspended,
    onPackageShortcut,
    onRedeemShortcut,
    onOpenDiscount,
    onOpenVoucher,
    onCloseDiscount,
    onCloseNote,
    onCloseCustomerHistory,
    onClearLineSelection,
    discountOpen,
    noteOpen,
    customerHistoryOpen,
    appointmentOpen,
    packageOpen,
    redeemOpen,
    paymentOpen,
    sale,
    selectedLineId,
    suspendedOpen,
  ])
}
